import React, { useContext } from 'react';

const AppContext = React.createContext({});

const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within a DataSourcesProvider');
  }
  return context;
};

export { useAppContext };

export default AppContext;
